<template>
  <div class="mode-guide-mask"
       @touchmove.stop="">
    <div class="obj"
         @click.stop="tapChest"></div>
    <div class="ico-point">
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    tapChest() {
      this.onTap && this.onTap()
    },
    close() {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
.mode-guide-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  .obj {
    position: absolute;
    top: 800px;
    left: 174px;
    width: 70px;
    height: 140px;
    // background-color: rgba($color: #000000, $alpha: 0.5);
  }
  .ico-point {
    position: absolute;
    top: 880px;
    left: 304px;
    width: 181px;
    height: 424px;
    width: 127px;
    height: 127px;
    background-image: url("../../assets/ico/ico-point.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    animation: move 2s linear infinite;
  }
  @keyframes move {
    0%,
    100% {
      transform: translateX(-40px) translateY(-40px);
    }
    50% {
      transform: translateX(-0) translateY(-0);
    }
  }
}
</style>